import siteRoutes from './site/routes'
import solutionsRoutes from './solutions/routes'
import blogRoutes from './blog/routes'
import staticRoutes from './static/routes'
import caseStudyRoutes from './casestudies/routes'

export default [
  ...blogRoutes,
  ...siteRoutes,
  ...caseStudyRoutes,
  ...staticRoutes,
  ...solutionsRoutes,
]
